import { Grid, Typography } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import { useContext } from 'react';
import useCommonStyles from '../../../../commonStyles';

import CheckBoxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { FEATURE_DESCRIPTION } from '../../constant';

/**
 * @name TerminateAdAfterDuration
 * @description This component is an editor for TerminateAdAfterDuration
 * ```
 *  {
 *  "terminateAdAfterDuration": { "enabled": true, "multiplier": 0.8 }
 *  }
 * ```
 * @param {{keyData: 'requestStructureData.terminateAdAfterDuration'}} keyData - A key used to identify the configuration in the `rawConfig` object.
 */
const TerminateAdAfterDuration = ({ keyData }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const { REQUEST_STRUCTURE_DATA } = FEATURE_DESCRIPTION;

	return (
		<Grid item className={commonStyleClasses.basicOutlinedBox}>
			<Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600 }}>
				Terminate ad after duration
			</Typography>
			<Typography variant="body2" sx={{ mb: 2, fontWeight: 600 }}>
				Terminate the ad when it reaches the configured percentage of its total duration.
			</Typography>

			<Grid container spacing={2} direction="column">
				<Grid item>
					<CheckBoxInput
						keyData={`${keyData}.enabled`}
						label="Enabled"
						disabled={false}
						style={{ marginTop: '0rem', width: '10%' }}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item sx={{ mt: '5rem' }}>
					<InputConfig
						label="Multiplier (b/w 0 and 1)"
						keyData={`${keyData}.multiplier`}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						editable={!!rawConfig[`${keyData}.enabled`]}
						showInfoButton={true}
						infoMessage={REQUEST_STRUCTURE_DATA.TERMINATE_AD_AFTER_DURATION_MULTIPLIER}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default TerminateAdAfterDuration;
